import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";

import { ErrorResponse } from "src/types/error-response.type";
import { ClientsResponse } from "src/types/request.type";
import { SuccessResponse } from "src/types/success-response.type";


export const clientsData3 = createAsyncThunk<ClientsResponse[], void>(
  "/clientsData3",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {
      // configure header's Content-Type as JSON

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };


      //console.log("export const clientsData3 = createAsyncThunk<ClientsResponse[], void>(")
      const response = await api.get(`/clients`, config);




      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const clientsDataUpdate3 = createAsyncThunk<
  ClientsResponse,
  ClientsResponse
>(
  "/clientsDataUpdate3",
  async (client, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: client.title, // This is the body part
      };

      const response = await api.patch(
        `/clients/${client.id}`,
        databody,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const clientsDataDelete3 = createAsyncThunk<
  SuccessResponse,
  ClientsResponse
>(
  "/clientsDataDelete3",
  async (client, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: client.title, // This is the body part
      };

      const response = await api.delete(
        `/clients/${client.id}`,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const clientsDataInsert3 = createAsyncThunk<
  SuccessResponse,
  string | undefined | null
>(
  "/clientsDataInsert3",
  async (clientid, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    console.log(clientid);

    if (clientid === null || typeof clientid === "undefined") {
      return rejectWithValue("Request ERROR");
    }

    try {

      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const databody = {
        title: clientid, // This is the body part
      };

      const response = await api.post(
        `/clients`,
        databody,
        config
      );

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);
